<template>
    <div class="horizontal-center">
        <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutDown" appear>
          <nav class="navbar navbar-expand-lg bg-custom animated">
              <div class="container">
                <router-link tag="a" to="/" class="navbar-brand"><img @click="scrollToTop" class="logo" src="~@/assets/images/logo.png"></router-link>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto"></ul>
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item">
                          <router-link tag="a" to="/" class="nav-link active" href="#1">{{ $t('nav.home') }}</router-link>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="#2">{{ $t('nav.about') }}</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="#3">{{ $t('nav.intro') }}</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="#4">{{ $t('nav.products') }}</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="#5">{{ $t('nav.projects') }}</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" href="#6">{{ $t('nav.partners') }}</a>
                        </li>
                    </ul>
                    <div class="navbar-form navbar-right">
                        <button class="btn btn-custom-outlined btn-sm" @click="toggle = true">{{ $t('nav.contact') }}</button>
                    </div>
                    <div class="btn-group">
                      <button type="button" class="btn btn-lang btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="dropDownToggle">
                        <img :src="require(`@/assets/images/flag/flag_${ $i18n.locale }.png`)">&nbsp;<span style="text-transform: uppercase !important;">{{ $i18n.locale }}</span>
                      </button>
                      <transition enter-active-class="animated bounceIn transition-1" leave-active-class="animated bounceOut" mode="out-in">
                      <div class="dropdown-menu show" :class="dropdownActive" v-if="dropdownActive">
                        <a  class="dropdown-item" style="cursor: pointer;"
                          v-on:click="setLocale('en')">
                          <img src="@/assets/images/flag/flag_en.png" class="mr-3">English
                        </a>
                        <a  class="dropdown-item" style="cursor: pointer;"
                          v-on:click="setLocale('th')">
                          <img src="@/assets/images/flag/flag_th.png" class="mr-3">ภาษาไทย
                        </a>
                      </div>
                      </transition>
                    </div>
                </div>
              </div>
          </nav>
        </transition>
  <transition enter-active-class="animated bounceIn" leave-active-class="animated bounceOut" appear>
    <div class="modal-mask" v-if="toggle">
      <div class="modal-wrapper"  @click.self="toggle = false">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <div class="col-12">
                <button type="button" class="close" @click="toggle = false">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 pl-0 pr-0 d-none d-sm-block">
                  <div>
                    <img src="@/assets/images/logo.png" width="120px">
                  </div>
                  <div class="mt-4">
                    <h5 class="title">Company</h5>
                    <p class="mt-3 subtitle">New IT Corporation</p>
                  </div>
                  <div class="mt-4">
                    <h5 class="title">Address</h5>
                    <p class="mt-3 col-8 col-lg-8 pl-0 pr-0 subtitle">99/209 Chaeng Watthana 12 Intersection 4-7-4-1 Thung Song Hong Subdistrict, Lak Si District, Bangkok</p>
                  </div>
                  <div class="mt-4">
                    <h5 class="title">Email</h5>
                    <p class="mt-3 subtitle">pongpaitoon@newitcorp.com<br/>support@newitcorp.com</p>
                  </div>
                  </div>
                  <form @submit.prevent="send" class="col-12 col-sm-6 col-md-6 col-lg-6 pl-0 pr-0">
                    <h4 class="mb-4" style="font-weight: 700 !important;">Contact Us</h4>
                    <div class="form-group input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="inputGroup-sizing"><i class="fas fa-user"></i></span>
                        </div>
                      <input type="text" class="form-control" required placeholder="Name" aria-describedby="inputGroup-sizing" v-model="recipient.name">
                    </div>
                    <div class="form-group input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroup-sizing"><i class="fas fa-envelope"></i></span>
                      </div>
                      <input type="email" class="form-control" required placeholder="Email" aria-describedby="inputGroup-sizing" v-model="recipient.email">
                    </div>
                    <div class="form-group input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroup-sizing"><i class="fas fa-book"></i></span>
                      </div>
                      <input type="text" class="form-control" placeholder="Subject" aria-describedby="inputGroup-sizing" v-model="recipient.subject">
                    </div>
                    <div class="form-group input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroup-sizing"><i class="fas fa-comment-dots"></i></span>
                      </div>
                      <textarea class="form-control" rows="3" placeholder="Message" aria-describedby="inputGroup-sizing" v-model="recipient.message"></textarea>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <button v-if="loading" class="btn btn-custom" type="button" disabled>
                          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                          {{ loading }}
                        </button>
                        <button v-else class="btn btn-custom">Send Message</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </transition>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
    <div class="modal-background" v-if="toggle"></div>
  </transition>

    </div>
</template>

<script>
import _ from 'lodash'
import $ from 'jquery'
import axios from 'axios'

$(document).ready(function () {
  $('a[href^="#"]').on('click', function (e) {
    e.preventDefault()
    var target = $(this).attr('href')
    $('html, body').animate({
      scrollTop: $(target).offset().top
    }, 800)
  })
  if ($(window.location.hash).length > 1) {
    $('html, body').animate({
      scrollTop: $(window.location.hash).offset().top
    }, 800)
  }
})

$(window).scroll(function () {
  var scrollDistance = $(window).scrollTop()
  $('.page-section').each(function (i) {
    if ($(this).position().top <= scrollDistance + 100) {
      $('.navbar #navbarSupportedContent').removeClass('show', 'easeInBack')
      $('.navbar a.nav-link.active').removeClass('active')
      $('.navbar a.nav-link').eq(i).addClass('active')
    }
  })
}).scroll()

export default {
  data () {
    return {
      isNav: false,
      isActive: false,
      dropdownActive: false,
      langs: ['en', 'th'],
      // languages: [
      //   {
      //     title: this.$t('languages.english'),
      //     value: 'en',
      //     img: require('@/assets/images/flag/flag_en.png')
      //   },
      //   {
      //     title: this.$t('languages.thailand'),
      //     value: 'th',
      //     img: require('@/assets/images/flag/flag_th.png')
      //   }
      // ],
      sidebar: {
        height: 0,
        windowHeight: 0,
        windowScrollTop: 0
      },
      user: JSON.parse(localStorage.getItem('user')),
      recipient: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },
      loading: '',
      status: '',
      toggle: false
    }
  },
  methods: {
    scrollToTop () {
      $('html, body').animate({
        scrollTop: 0
      }, 800)
      return false
    },
    send () {
      this.$Progress.start()
      this.loading = 'Sending...'
      const formData = new FormData()
      formData.append('recipient', JSON.stringify(this.recipient))
      axios.post('http://localhost:5000/sendmail', formData, {
        headers: { 'x-access-token': localStorage.getItem('token') }
      }).then(res => {
        this.$swal('Success', `${res.data.message}`, 'success')
        this.loading = ''
        this.status = res.data.message
        this.recipient.name = ''
        this.recipient.email = ''
        this.recipient.subject = ''
        this.recipient.message = ''
        this.toggle = false
      })
    },
    // changeLanguage (lang) {
    //   this.$Progress.start()
    //   this.dropdownActive = false
    //   this.$i18n.locale = lang.value
    //   this.$store.dispatch('language/setLanguage', lang.value)
    //   this.$router.push({
    //     params: { lang: lang.value }
    //   })
    // },
    dropDownToggle () {
      this.dropdownActive = !this.dropdownActive
    },
    setLocale (locale) {
      this.$i18n.locale = locale
      this.$Progress.start()
      this.dropdownActive = false
      this.$router.push({
        params: { lang: locale }
      })
    },
    close () {
      this.toggleModal = false
    },
    calculateNavbar () {
      this.sidebar.height = this.$refs.navbarContent.offsetHeight
      // this.sidebar.windowHeight = window.innerHeight
    },
    handleScrollActive () {
    },
    handleNavbar: _.throttle(function () {
      this.calculateNavbar()
    }, 100),
    handleScroll: _.throttle(function () {
      this.sidebar.windowScrollTop = window.pageYOffset || document.documentElement.scrollTop
    }, 100)
  },
  mounted () {
    // this.calculateNavbar()
  },
  computed: {
    // navbarStyle () {
    //   if (this.sidebar.windowScrollTop > this.sidebar.height) {
    //     return { 'navbar-top': true }
    //   } else {
    //     return { 'navbar-top': false }
    //   }
    //   if ((this.sidebar.windowScrollTop + this.sidebar.windowHeight) > this.sidebar.height)
    //       return { 'navbar-bottom': true }
    // },
    flag () {
      return this.$i18n.locale
    }
  },
  created () {
    // window.addEventListener('resize', this.handleNavbar)
    // window.addEventListener('scroll', this.handleScroll)
    // window.addEventListener('scroll', this.handleScrollActive)
  },
  destroyed () {
    // window.removeEventListener('scroll', this.handleScrollActive)
  }
}
</script>
